// src/pages/Dashboard/ChartsSection.tsx
import React from 'react';
import { Row, Col, Card } from 'antd';
import { Line, Pie } from '@ant-design/charts';

const ChartsSectionContainer: React.FC = () => {
  // MRR Trend Data
  const mrrData = [
    { month: 'T1', mrr: 180000000 },
    { month: 'T2', mrr: 165000000 },
    { month: 'T3', mrr: 195000000 },
    { month: 'T4', mrr: 210000000 },
    { month: 'T5', mrr: 245000000 },
    { month: 'T6', mrr: 230000000 },
    { month: 'T7', mrr: 260000000 },
    { month: 'T8', mrr: 275000000 },
    { month: 'T9', mrr: 290000000 },
    { month: 'T10', mrr: 310000000 },
    { month: 'T11', mrr: 295000000 },
    { month: 'T12', mrr: 325000000 },
  ];

  const lineConfig = {
    data: mrrData,
    xField: 'month',
    yField: 'mrr',
    smooth: true,
    point: { size: 5 },
    lineStyle: { stroke: '#13C2C2' },
    yAxis: { label: { formatter: (v: number) => `${(v / 1000000).toFixed(0)}M` } },
  };

  // Phân khúc khách hàng
  const segmentData = [
    { type: 'Enterprise', value: 62 },
    { type: 'SME', value: 28 },
    { type: 'Startup', value: 10 },
  ];

  const pieConfig = {
    data: segmentData,
    angleField: 'value',
    colorField: 'type',
    radius: 0.75,
    label: { type: 'inner', content: '{percentage}%' },
    legend: { position: 'bottom' as const },
  };

  return (
    <Row gutter={[16, 16]}>
      <Col xs={24} lg={16}>
        <Card title="MRR Trend 12 Tháng">
          <Line {...lineConfig} />
        </Card>
      </Col>
      <Col xs={24} lg={8}>
        <Card title="Phân khúc khách hàng" >
          <Pie {...pieConfig} />
        </Card>
      </Col>
    </Row>
  );
};

export { ChartsSectionContainer };